import { render, staticRenderFns } from "./DropdownAccordion.vue?vue&type=template&id=28f04445&scoped=true"
import script from "./DropdownAccordion.vue?vue&type=script&lang=js"
export * from "./DropdownAccordion.vue?vue&type=script&lang=js"
import style0 from "./DropdownAccordion.vue?vue&type=style&index=0&id=28f04445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f04445",
  null
  
)

export default component.exports